import { useState, useEffect } from 'react';

// Binance public API – no key required, CORS supported
const URL = 'https://api.binance.com/api/v3/ticker/24hr?symbols=["BTCUSDT","ETHUSDT","SOLUSDT"]';

export function useCryptoPrices() {
  const [prices, setPrices] = useState({
    btc: 0, btcChange: 0,
    eth: 0, ethChange: 0,
    sol: 0, solChange: 0,
    loaded: false,
  });

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const res = await fetch(URL);
        if (!res.ok) return;
        const data = await res.json();
        if (!mounted) return;

        const get = (sym) => data.find(d => d.symbol === sym);
        const btc = get('BTCUSDT');
        const eth = get('ETHUSDT');
        const sol = get('SOLUSDT');

        setPrices({
          btc:       btc ? parseFloat(btc.lastPrice)          : 0,
          btcChange: btc ? parseFloat(btc.priceChangePercent) : 0,
          eth:       eth ? parseFloat(eth.lastPrice)          : 0,
          ethChange: eth ? parseFloat(eth.priceChangePercent) : 0,
          sol:       sol ? parseFloat(sol.lastPrice)          : 0,
          solChange: sol ? parseFloat(sol.priceChangePercent) : 0,
          loaded: true,
        });
      } catch (e) {
        // garde les valeurs précédentes en cas d'erreur réseau
      }
    };

    load();
    const timer = setInterval(load, 30000); // rafraîchit toutes les 30s
    return () => { mounted = false; clearInterval(timer); };
  }, []);

  return prices;
}

// Formatteur footer : $72000 → $72.0K, $84.69 → $84.69
export function fmtFooterPrice(p) {
  if (!p) return '$—';
  if (p >= 1000) return `$${(p / 1000).toFixed(1)}K`;
  if (p >= 100)  return `$${p.toFixed(0)}`;
  return `$${p.toFixed(2)}`;
}
